import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head, Link } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
export default {
  components: {
    Head: Head,
    Link: Link
  },
  layout: Layout,
  props: {
    weeks: {
      type: Number,
      "default": 0
    }
  },
  mounted: function mounted() {
    if (this.weeks != 0) {
      this.getTargetData();
    }
  },
  data: function data() {
    return {
      weekDataList: {},
      targetDataList: [],
      isLoadingTargetData: false,
      currentPage: 1,
      valueType: "percentage",
      tabsData: [],
      user_id: null,
      reportType: "user"
    };
  },
  methods: {
    pageChange: function pageChange(current_page) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.currentPage = current_page;
                _this.getTargetData();
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getTargetData: function getTargetData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var url, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = '/target/get_user_data';
                if (_this2.reportType == "user_account") {
                  url = '/target/user_account_data';
                }
                _this2.isLoadingTargetData = true;
                _this2.weekDataList = [];
                _context2.next = 6;
                return axios.post(url, {
                  page: _this2.currentPage,
                  userId: _this2.user_id
                });
              case 6:
                res = _context2.sent;
                if (res.data.status == 'success') {
                  _this2.weekDataList = res.data.weekDataList;
                  _this2.targetDataList = res.data.targetDataList;
                }
                _this2.isLoadingTargetData = false;
              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getUserData: function getUserData(row) {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var type, tab;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                type = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : "table";
                if (!(type == "table" && _this3.reportType == 'user_account')) {
                  _context3.next = 3;
                  break;
                }
                return _context3.abrupt("return");
              case 3:
                tab = {
                  "user_id": row.user_id,
                  "user_name": row.user_name,
                  "user_type": row.user_type
                };
                _this3.tabsData.push(tab);
                _this3.user_id = row.user_id;
                if (row.user_type == 'employee') {
                  _this3.reportType = "user_account";
                } else {
                  _this3.reportType = "user";
                }
                _context3.next = 9;
                return _this3.getTargetData();
              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    goBack: function goBack(tab, tab_key) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.tabsData.splice(tab_key);
                _context4.next = 3;
                return _this4.getUserData(tab, "back");
              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    reset: function reset() {
      this.tabsData = [];
      this.user_id = null;
      this.getTargetData();
    }
  }
};